module.exports = __webpack_public_path__ + "static/media/upload-arrow.498df973.svg";